export class AccountAssociationRequest {
    registrationId: number;
    acctNumber: number;
    organizationId: number;
    syncStudents: boolean;
    syncStudentContacts: boolean;
    // syncEnabled: boolean;

    constructor() {
        this.registrationId = 0;
        this.acctNumber = 0;
        this.organizationId = 0;
        this.syncStudents = true;
        this.syncStudentContacts = true;
        // this.syncEnabled = true;
    }
}